import React, {useState} from 'react';
import { useFormContext } from '../Provider';
import useValidators from '../Validators/useValidator';
import CommonFieldWrapper from './CommonFieldWrapper';
import Toggle from '../../Button/Toggle';
import { useFieldPanelHelper } from '../../Containers/Accordion/Panel';

const ANY = 'Any';
const fallbackValue = {};

const ScheduleConstraints = ({label, name, help, onChange, disabled, validators}) => {
    const { formData, updateField, updateValidity, isValidating, isSubmitting, formDisabled } = useFormContext();
    const value = formData[name] ?? fallbackValue;

    const {isValid, error} = useValidators(value, validators, name, updateValidity);
    const [scheduleConstraintsEnabled, setScheduleConstraintsEnabled] = useState(
        !!(value?.dayOfWeek ?? value?.weekOfMonth ?? value?.timeRange?.from ?? value?.timeRange?.to ?? false)
    );

    useFieldPanelHelper(name, value, isValid);

    const toggleEnabled = (on) => {
        setScheduleConstraintsEnabled(on)
        handleChange(on ? {} : {});
    }

    const handleChange = (newVal) => {
        updateField(name, newVal);
        onChange && onChange(newVal);
    }

    const changeField = (field, val, subfield) => {
        if (subfield) {
            const newVal = {...(value ?? {})};
            if (!newVal[field]) {
                newVal[field] = {};
            }
            newVal[field][subfield] = val;
            handleChange(newVal);
        } else {
            handleChange({...(value ?? {}), [field]: val});
        }
    }

    const isDisabled = formDisabled || disabled || isSubmitting;

    return <CommonFieldWrapper {...{label, name, help, value, isValid, isValidating, error, validators, isDisabled}}>

        <Toggle enabled={scheduleConstraintsEnabled} onChange={toggleEnabled} label={'Advanced Scheduling'} disabled={isDisabled} hideFocusRing />

        {scheduleConstraintsEnabled && <>
            <p className="mt-2">
                <label htmlFor="dayOfWeek" className="inline-block w-full text-xs font-medium text-gray-600 text-left">Day of week</label>
                <select
                    id="dayOfWeek"
                    name="dayOfWeek"
                    className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                    value={value?.dayOfWeek ?? ANY}
                    onChange={e => changeField('dayOfWeek', e.target.value)}
                    disabled={isDisabled}
                >
                    <option value={ANY}>Any day</option>
                    <option value="Monday">Monday</option>
                    <option value="Tuesday">Tuesday</option>
                    <option value="Wednesday">Wednesday</option>
                    <option value="Thursday">Thursday</option>
                    <option value="Friday">Friday</option>
                    <option value="Saturday">Saturday</option>
                    <option value="Sunday">Sunday</option>
                </select>
            </p>

            <p className="mt-2">
                <label htmlFor="weekOfMonth" className="inline-block w-full text-xs font-medium text-gray-600 text-left">Week of month</label>
                <select
                    id="weekOfMonth"
                    name="weekOfMonth"
                    className="block w-full ml-1 p-0 border-0 border-transparent focus:border-transparent text-gray-900 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                    value={value?.weekOfMonth ?? ANY}
                    onChange={e => changeField('weekOfMonth', e.target.value)}
                    disabled={isDisabled}
                >
                    <option value={ANY}>Any week</option>
                    <option value="1">First</option>
                    <option value="2">Second</option>
                    <option value="3">Third</option>
                    <option value="4">Fourth</option>
                    <option value="5">Fifth</option>
                </select>
            </p>

            <div className="mt-2">
                <label className="inline-block text-xs font-medium w-full text-gray-600 text-left">Time of day</label>
                <div className="relative flex flex-row">
                    <div className="grow px-2 text-sm text-muted">
                        <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                            type="time"
                            name="timeRangeFrom"
                            value={value?.timeRange?.from ?? ''}
                            onChange={e => changeField('timeRange', e.target.value, 'from')}
                            min="00:00"
                            max="23:59"
                            step="300"
                            disabled={isDisabled}
                        />
                        {/* From */}
                    </div>
                    <div className="px-2 text-sm text-muted">
                        -
                    </div>
                    <div className="grow px-2 text-sm text-muted">
                        <input className="block w-full border-0 p-0 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6 disabled:text-gray-400 disabled:bg-gray-100"
                            type="time"
                            name="timeRangeTo"
                            value={value?.timeRange?.to ?? ''}
                            onChange={e => changeField('timeRange', e.target.value, 'to')}
                            min="00:00"
                            max="23:59"
                            step="300"
                            disabled={isDisabled}
                        />
                        {/* To */}
                    </div>
                </div>
            </div>
        </>}

    </CommonFieldWrapper>
}

export default ScheduleConstraints;